import { useState } from 'react';
import type { Reservation } from '../lib/types';

export function CancelModal({
  target,
  saving,
  onConfirm,
  onClose,
}: {
  target: Reservation;
  saving: boolean;
  onConfirm: (
    target: Reservation,
    canceledBy: string,
    cancellationReason: string,
  ) => void;
  onClose: () => void;
}) {
  const [canceledBy, setCanceledBy] = useState('');
  const [reason, setReason] = useState('');
  const ready = canceledBy.trim() !== '' && reason.trim() !== '';

  return (
    <div className="modal-overlay is-nested" onClick={onClose}>
      <div
        className="modal"
        style={{ maxWidth: 400 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <span
            style={{ fontSize: 15, fontWeight: 500, color: 'var(--text-primary)' }}
          >
            Cancel reservation
          </span>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div
          style={{
            background: 'var(--red-bg)',
            border: '0.5px solid var(--red-bd)',
            borderRadius: 'var(--radius)',
            padding: '10px 12px',
            marginBottom: 14,
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--red-fg)' }}>
            {target.projectNumber} – {target.projectName}
          </div>
          <div style={{ fontSize: 11, color: 'var(--red-fg)', marginTop: 3 }}>
            {target.equipment || 'Unassigned'} · {target.startDate} →{' '}
            {target.endDate}
          </div>
          {/* Says what cancelling actually costs. The API refuses to edit
              or reschedule a cancelled booking — its fields are the record
              of what was cancelled — so this is a one-way door. */}
          <div
            style={{
              fontSize: 11,
              color: 'var(--red-fg)',
              marginTop: 6,
              fontWeight: 500,
            }}
          >
            This can't be undone. A cancelled booking can't be edited or
            rescheduled — you'd have to raise a new one.
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div>
            <label className="form-label">Canceled by</label>
            <input
              style={{ width: '100%' }}
              placeholder="Your name"
              value={canceledBy}
              onChange={(e) => setCanceledBy(e.target.value)}
            />
          </div>
          <div>
            <label className="form-label">Reason</label>
            <input
              style={{ width: '100%' }}
              placeholder="Reason for cancellation"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button
              className="btn-save"
              style={{
                background: 'var(--red-bg)',
                color: 'var(--red-fg)',
                borderColor: 'var(--red-bd)',
              }}
              disabled={saving || !ready}
              onClick={() => onConfirm(target, canceledBy.trim(), reason.trim())}
            >
              {saving ? 'Canceling…' : 'Confirm cancellation'}
            </button>
            <button className="btn-cancel" onClick={onClose}>
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
